import * as React from "react";

export const GreenCircleCheckIcon: React.SFC = ({}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15ZM7.5 10.6275L12.4425 5.685L13.5 6.75L7.5 12.75L4.5 9.75L5.5575 8.6925L7.5 10.6275Z"
      fill="#14AA2E"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/login/GreenCircleCheckIcon.tsx